import React from 'react';
import Translate, {t} from "../../../../../../../components/Translate";
import Input from "../../../../../../../components-new/Input";
import config from "../../../../../../../config";
import BlueButton from "../../../../../../../components-new/buttons/BlueButton";
import {endSubCompanyUnmanagedConversationsWithMessage} from "../../../../../../../services/company/api";
import {addNotification as addNotificationAction} from "../../../../../../../services/notification/action";
import {connect} from "react-redux";
import {silverInfoStyles} from "../../../../../../../utils/General";

const EndChatsSpace = ({client, user, endChatsText, setEndChatsText, endMin, setEndMin, addNotification}) => {

    const handleClick = () => {
        if (endChatsText === '') {
            addNotification('textMustNotBeEmpty', config.notificationLevels.error);
            return;
        }
        endSubCompanyUnmanagedConversationsWithMessage(client.id, endChatsText, endMin)
            .then(() => {
                addNotification('successful', config.notificationLevels.success);
                setEndChatsText("");
                setEndMin(0);
            })
            .catch(() => {
                addNotification('somethingWentWrong', config.notificationLevels.error);
            })
    }

    return (
        <div style={{
            padding: '10px',
            margin: '20px auto',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            maxWidth: '800px',
        }}>
            <h2 style={{fontSize: '16px', color: 'rgb(164, 173, 193)', marginBottom: '20px'}}>
                <Translate text={'unmanagedChatsEndSettingHeader'}/>
            </h2>

            <div style={{
                display: 'flex',
                gap: '15px',
                flexDirection: 'column',
                marginTop: '10px',
                alignItems: 'center',
                justifyContent: 'center'
            }}>

                <h2 style={{...silverInfoStyles.info, marginLeft: '0px', marginBottom: '20px', textAlign: 'center'}}>
                    <Translate text="chatsFunctionInfo"/>
                </h2>

                <Input
                    type="number"
                    name="interval"
                    value={endMin}
                    style={{width: '100px'}}
                    onChange={(e) => setEndMin(e.target.value)}
                    min={0}
                />

                <Input
                    placeholder={t({text: "message", user})}
                    value={endChatsText} onChange={(e) => setEndChatsText(e.target.value)}
                    isTextarea={true}/>

                <br/>

                <div style={{display: 'flex', flexDirection: 'column', gap: '5px'}}>
                    <BlueButton
                        width={'500px'}
                        children={<Translate text={'sendAndEnd'}/>}
                        onClick={handleClick}
                    />
                </div>

            </div>
        </div>
    );
};

const mapDispatchToProps = {
    addNotification: addNotificationAction,
};

export default connect(null, mapDispatchToProps)(EndChatsSpace);



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/clients/new/configurations/EndChatsSpace.jsx